export default [
  {
    path: '/monthly-attendences',
    name: 'monthly-attendence',
    meta: { requiresAuth: true },
    component: () => import('@/pages/monthly-attendence/index.vue')
  }
]
